import React from 'react'
import { Helmet } from 'react-helmet'

import { Navbar, Footer, Landing, About, Skills, Projects, Contacts, Services } from '../../components'
import { headerData } from '../../data/headerData'

function Main() {
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - {headerData.title3}</title>
            </Helmet>
            <Navbar />        
            <Landing />
            <Services />
            <About />
            <Skills />
            <Projects />
            <Contacts />
            <Footer />
        </div>
    )
}

export default Main
